import { classnames } from 'tailwindcss-classnames';
import { useScreenBreakpoint } from 'lib/util/useScreenWidth';
import { useState } from 'react';
import Container from 'components/helpers/Container';
import { ReactDesktopTabsHorizontalLayout } from 'components/helpers/Tabs/_ReactDesktopTabsHorizontalLayout';
import { ReactTabsProps } from './_types';
import { ReactMobileTabsLayout } from './_ReactMobileTabsLayout';
import ReactTabsSkeleton from './_ReactTabsSkeleton';

const ReactTabs = ({ tabs }: ReactTabsProps) => {
  const { isWideScreen, isInitializing } = useScreenBreakpoint();
  const firstItemId = tabs.length > 0 ? tabs[0].name : null; // Get the ID of the first item
  const [visibleItem, setVisibleItem] = useState<string | null>(firstItemId); // Initialize visibleItem state with the ID of the first item
  const [isOpenMobile, setIsOpenMobile] = useState<boolean[]>(tabs.map(() => false));
  const isMobileView = !isWideScreen; // isWideScreen is >990px, so !isWideScreen matches <=990px

  const toggleCategory = (index: number) => {
    // Toggle the state for the specified category
    return setIsOpenMobile((prevIsOpen) => {
      const newState = [...prevIsOpen];
      newState[index] = !newState[index];
      return newState;
    });
  };
  const toggleItemVisibility = (id: string | null) => {
    // Check if the clicked tab is already open (note doesn't react setState handle this for us?)
    if (visibleItem === id) {
      // If it is, do nothing
      return visibleItem;
    }
    return setVisibleItem((prevItem: string | null) => (prevItem === id ? null : id));
  };

  // Show skeleton during initial screen width detection to prevent layout shift
  if (isInitializing) {
    return <ReactTabsSkeleton />;
  }

  return (
    <Container size="standard" dataComponent="react/general/tabs">
      <div className={classnames('mt-[25px]', 'lg:min-h-[430px]')}>
        {isMobileView ? (
          <ReactMobileTabsLayout
            toggleCategory={toggleCategory}
            isOpenMobile={isOpenMobile}
            tabs={tabs}
          />
        ) : (
          <ReactDesktopTabsHorizontalLayout
            tabs={tabs}
            visibleItem={visibleItem}
            toggleItemVisibility={toggleItemVisibility}
          />
        )}
      </div>
    </Container>
  );
};

export default ReactTabs;
